import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * Floating footer that looks like a "Accept cookies" banner.
 * It displays whatever `content`.
 *
 * @param {Renderable} [content] - Content of the banner
 */
export default class FloatingFooter extends Widget {
	constructor({ content }) {
		super(...arguments);
		this._content = content;
	}

	renderContentOn(html) {
		html.div({ klass: "floating-footer" }, this._content);
	}
}
